<script lang="ts" setup>
import { ButtonStyle } from '~/static/enums/components/button'
import AButton from '~/components/atoms/buttons/Button.vue'
import RModal from '~/components/organs/Modal.vue'
import ABaseInput from '~/components/atoms/forms/BaseInput.vue'
import { InputType } from '~/static/enums/components/base-input'
import { closeModal } from '~/utils/Modal'

const emit = defineEmits<{
  (e: 'create', name: string): void
}>()

const name = ref('Без названия')
const error = ref('')

const changeName = (value: string) => {
  name.value = value
}
const create = () => {
  if (name.value.length === 0) {
    error.value = 'Укажите название'
    return
  }
  emit('create', name.value)
  closeModal()
}
const cancel = () => {
  closeModal()
}

</script>

<template>
  <RModal
    ref="refModal"
    name-modal="nameChangeModal"
    @close="cancel"
  >
    <template #header>
      <h5
        class="modal-title fs-5"
        id="nameChangeModalLabel"
      >
        Новая папка
      </h5>
    </template>

    <template #body>
      <div class="body">
        <span class="d-block mb-2">Название папки</span>
        <ABaseInput
          placeholder="Без названия"
          class="mb-lg-5"
          :value="name"
          :type="InputType.Text"
          :error-message="error"
          @change="changeName"
          @input="changeName"
          @enter="create"
        />
      </div>
    </template>
    <template #footer>
      <AButton
        :button-style="ButtonStyle.Primary"
        @click="create"
      >
        Создать
      </AButton>
    </template>
  </RModal>
</template>

<style lang="scss" scoped>
.body {
  width: 100%;
}
</style>
